import Defaults from '~/scripts/constants/defaults';

/**
 * @ngdoc function
 * @name app.controller:DevCtrl
 * @description
 * # DevCtrl
 * Controller of the app
 */
angular.module('app')
	.controller('DevCtrl', /* @ngInject */ ($scope, Notification) => {
		$scope.testsm1 = {
			kid:  'K_NODE;123',
			name: 'Test',
		};
		// $scope.testsm2 = {};

		$scope.dev = {
			test1:  [
				{
					kid:  'K_NODE;PERSON',
					name: 'Personne',
				},
			],
			test11: [
				{
					kid: 'K_NODE;PERS_OLIVIER', isa: 'K_NODE;PERSON', isa_name: 'Personne', name: 'Olivier BERAUD',
				},
			],
		};

		$scope.testUniqueOptions = {
			icon:      false,
			uniqueKid: true,
			linkerKid: true,
		};

		$scope.tmp = {
			card:       {
				from: 0,
				to:   Defaults.KCARDN,
			},
			testUnique: '0',
		};

		$scope.smartFieldValidator = {
			custom: `
		console.log('input', input);
		`,
		};

		$scope.selected = undefined;
		$scope.states = [
			'Alabama',
			'Alaska',
			'Arizona',
			'Arkansas',
			'California',
			'Colorado',
			'Connecticut',
			'Delaware',
			'Florida',
			'Georgia',
			'Hawaii',
			'Idaho',
			'Illinois',
			'Indiana',
			'Iowa',
			'Kansas',
			'Kentucky',
			'Louisiana',
			'Maine',
			'Maryland',
			'Massachusetts',
			'Michigan',
			'Minnesota',
			'Mississippi',
			'Missouri',
			'Montana',
			'Nebraska',
			'Nevada',
			'New Hampshire',
			'New Jersey',
			'New Mexico',
			'New York',
			'North Dakota',
			'North Carolina',
			'Ohio',
			'Oklahoma',
			'Oregon',
			'Pennsylvania',
			'Rhode Island',
			'South Carolina',
			'South Dakota',
			'Tennessee',
			'Texas',
			'Utah',
			'Vermont',
			'Virginia',
			'Washington',
			'West Virginia',
			'Wisconsin',
			'Wyoming',
		];

		// NodeService.load('K_NODE;PERSON').then(function(person) {
		// 	console.log(person);
		// });

		$scope.test2 = [];

		$scope.selectNode = function (item, e) {
			console.log('selectNode', item, e, $scope.asyncSelected);
		};

		$scope.createNode = function (query, e) {
			console.log('create', query, e, $scope.asyncSelected);
		};

		$scope.form = {
			components: [
				{
					clearOnHide: false,
					key:         'undefinedPanel',
					input:       false,
					title:       'Informations générales',
					theme:       'primary',
					tableView:   false,
					collapsible: true,
					collapsed:   false,
					components:  [
						{
							clearOnHide: false,
							label:       'Columns',
							input:       false,
							tableView:   false,
							key:         'undefinedPanelColumns',
							columns:     [
								{
									components: [
										{
											autofocus:   false,
											input:       true,
											order:       'K_NODE;LASTNAME',
											inputType:   'text',
											tableView:   true,
											label:       'Nom de famille (create=false)',
											key:         'K_NODE;LASTNAME',
											placeholder: 'Nom de famille',
											multiple:    false,
											values:      [],
											validate:    {
												card:   '1-1',
												custom: 'if(component.validate.card){var tmpcard=component.validate.card.split(\'-\');if(data.length<parseInt(tmpcard[0])||tmpcard[1]!==\'N\'&&data.length>parseInt(tmpcard[1])){valid=\'Veuillez sélectionner entre \'+tmpcard[0]+\' et \'+tmpcard[1]+\' élement(s)\';}else{valid=true;}}else{valid=true;}',
											},
											conditional: { show: null, when: null, eq: '' },
											type:        'mf',
											properties:  { kid: 'K_NODE;LASTNAME' },
											create:      false,
										},
									],
									width:      6,
									offset:     0,
									push:       0,
									pull:       0,
								},
								{
									components: [
										{
											autofocus:   false,
											input:       true,
											order:       'K_NODE;FIRSTNAME',
											inputType:   'text',
											tableView:   true,
											label:       'Prénom',
											key:         'K_NODE;FIRSTNAME',
											placeholder: 'Prénom',
											multiple:    false,
											values:      [],
											validate:    {
												card: '1-2',
											},
											conditional: { show: null, when: null, eq: '' },
											type:        'mf',
											properties:  { kid: 'K_NODE;FIRSTNAME' },
											create:      true,
										},
									],
									width:      6,
									offset:     0,
									push:       0,
									pull:       0,
								},
							],
							type:        'columns',
							hideLabel:   true,
							tags:        [],
							conditional: { show: '', when: null, eq: '' },
							properties:  {},
						},
						{
							autofocus:      false,
							input:          true,
							tableView:      true,
							label:          'Date de naissance',
							key:            'K_NODE;BIRTHDAY',
							placeholder:    'Date de naissance',
							format:         'dd/MM/yyyy',
							enableDate:     true,
							enableTime:     false,
							defaultDate:    '',
							datepickerMode: 'day',
							datePicker:     {
								showWeeks:      false,
								startingDay:    '1',
								initDate:       '',
								minMode:        'day',
								maxMode:        'year',
								yearRows:       4,
								yearColumns:    5,
								minDate:        null,
								maxDate:        null,
								datepickerMode: 'day',
							},
							timePicker:     {
								hourStep:      1,
								minuteStep:    1,
								showMeridian:  false,
								readonlyInput: false,
								mousewheel:    true,
								arrowkeys:     true,
							},
							protected:      false,
							persistent:     true,
							hidden:         false,
							clearOnHide:    true,
							validate:       { required: false, custom: '' },
							type:           'datetime',
							properties:     { kid: 'K_NODE;BIRTHDAY' },
							labelPosition:  'top',
							tags:           [],
							conditional:    { show: '', when: null, eq: '' },
						},
						{
							autofocus:     false,
							input:         true,
							inputType:     'text',
							tableView:     true,
							label:         'Smart Field',
							key:           'undefinedSmartField',
							placeholder:   'Personne (3-20)',
							multiple:      false,
							kdata:         {
								mf_order: 'K_NODE;PERSON',
							},
							conditional:   {
								show: '',
								when: null,
								eq:   '',
							},
							validate:      {
								required:      true,
								minLength:     null,
								maxLength:     null,
								pattern:       '\\d{13}',
								custom:        '',
								customPrivate: false,
							},
							type:          'smartfield',
							labelPosition: 'top',
							tags:          [],
							properties:    {},
						},
					],
					type:        'panel',
					breadcrumb:  'default',
					hideLabel:   true,
					tags:        [],
					conditional: { show: '', when: null, eq: '' },
					properties:  {},
					label:       'undefinedPanel',
				},
				{
					autofocus:     false,
					input:         true,
					tableView:     true,
					inputType:     'text',
					inputMask:     '',
					label:         'Text1',
					key:           'undefinedText1',
					placeholder:   '',
					prefix:        '',
					suffix:        '',
					multiple:      false,
					defaultValue:  '',
					protected:     false,
					unique:        false,
					persistent:    true,
					hidden:        false,
					clearOnHide:   true,
					spellcheck:    true,
					validate:      {
						required:      false,
						minLength:     '',
						maxLength:     '',
						pattern:       '',
						custom:        'valid=(input===\'3\')?true:"error!!!";',
						customPrivate: false,
					},
					conditional:   { show: '', when: null, eq: '' },
					type:          'textfield',
					labelPosition: 'top',
					tags:          [],
					properties:    {},
				},
				{
					autofocus:     false,
					input:         true,
					tableView:     true,
					inputType:     'text',
					inputMask:     '',
					label:         'Text2',
					key:           'undefinedText2',
					placeholder:   '',
					prefix:        '',
					suffix:        '',
					multiple:      false,
					defaultValue:  '',
					protected:     false,
					unique:        false,
					persistent:    true,
					hidden:        false,
					clearOnHide:   true,
					spellcheck:    true,
					validate:      {
						required:      false,
						minLength:     '',
						maxLength:     '',
						pattern:       '',
						custom:        '',
						customPrivate: false,
					},
					conditional:   { show: '', when: null, eq: '' },
					type:          'textfield',
					labelPosition: 'top',
					tags:          [],
					properties:    {},
				},
			],
			display:    'form',
			page:       0,
			prefix:     '',
			name:       'Personne',
		};
		$scope.readonly = false;

		$scope.notif = {
			title: 'My title',
			text:  'My text',
			send:  type => {
				Notification({
					type,
					title:   $scope.notif.title,
					message: $scope.notif.text,
				});
			},
		};

		$scope.setSubmission1 = function () {
			$scope.submission = {
				data: {
					'K_NODE;LASTNAME':  [{ kid: 'K_NODE;LN_BERAUD', name: 'BERAUD' }],
					'K_NODE;FIRSTNAME': [{ kid: 'K_NODE;FN_OLIVIER', name: 'Olivier' }],
					'K_NODE;BIRTHDAY':  new Date('1978-06-04'),
					undefinedText1:     'test1',
					undefinedText2:     'test2',
				},
			};
		};

		$scope.setSubmission2 = function () {
			$scope.submission = {
				data: {
					'K_NODE;LASTNAME':  [{ kid: 'K_NODE;LN_DESFORGES', name: 'DESFORGES' }],
					'K_NODE;FIRSTNAME': [{ kid: 'K_NODE;FN_FREDERIC', name: 'Frédéric' }],
					'K_NODE;BIRTHDAY':  null,
					undefinedText1:     'test3',
					undefinedText2:     'test4',
				},
			};
		};

		$scope.clearSubmission = function () {
			$scope.submission = {
				data: {},
			};
		};

		$scope.setSubmission1();

		$scope.ktableQuery = {
			select: [
				{
					inherits_extended: -1,
					kid:               'K_NODE;PERSON',
					hidden:            true,
					name:              'Personne',
					node:              'REPRE',
					op:                'detail',
					path:              [{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null }],
					type:              'K_NODE;STRING',
				},
				{
					inherits_extended: -1,
					kid:               'K_NODE;CIVILITY',
					linker_kid:        '0',
					linker_info:       {},
					hidden:            false,
					name:              'Civilité',
					node:              'REPRE',
					op:                'detail',
					path:              [
						{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;CIVILITY', name: 'Civilité', flow: 'down', linker_kid: 0,
						},
					],
					type:              'K_NODE;STRING',
				},
				{
					inherits_extended: -1,
					kid:               'K_NODE;FIRSTNAME',
					linker_kid:        '0',
					linker_info:       {},
					hidden:            false,
					name:              'Prénom',
					node:              'REPRE',
					op:                'detail',
					path:              [
						{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;FIRSTNAME', name: 'Prénom', flow: 'down', linker_kid: 0,
						},
					],
					type:              'K_NODE;STRING',
				},
				{
					inherits_extended: -1,
					kid:               'K_NODE;EMAIL',
					linker_kid:        '0',
					linker_info:       {},
					hidden:            false,
					name:              'Email',
					node:              'REPRE',
					op:                'detail',
					path:              [
						{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;EMAIL', name: 'Email', flow: 'down', linker_kid: 0,
						},
					],
					type:              'K_NODE;STRING',
				},
				{
					inherits_extended: -1,
					kid:               'K_NODE;PHONECOORD',
					linker_kid:        '0',
					linker_info:       {},
					hidden:            false,
					name:              'Coordonnée téléphonique',
					node:              'REPRE',
					op:                'detail',
					path:              [
						{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;PHONECOORD', name: 'Coordonnée téléphonique', flow: 'down', linker_kid: 0,
						},
					],
					type:              'K_NODE;STRING',
				},
				{
					inherits_extended: -1,
					kid:               'K_NODE;ADDRESSCOORD',
					linker_kid:        '0',
					linker_info:       {},
					hidden:            false,
					name:              'Coordonnée postale',
					node:              'REPRE',
					op:                'detail',
					path:              [
						{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;ADDRESSCOORD', name: 'Coordonnée postale', flow: 'down', linker_kid: 0,
						},
					],
					type:              'K_NODE;STRING',
				},
				{
					inherits_extended: -1,
					kid:               'K_NODE;BIRTHDAY',
					linker_kid:        '0',
					linker_info:       {},
					hidden:            false,
					name:              'Date de naissance',
					node:              'REPRE',
					op:                'detail',
					path:              [
						{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;BIRTHDAY', name: 'Date de naissance', flow: 'down', linker_kid: 0,
						},
					],
					type:              'K_NODE;DATE',
				},
				{
					inherits_extended: -1,
					kid:               'K_NODE;LASTNAME',
					linker_kid:        '0',
					linker_info:       {},
					hidden:            false,
					name:              'Nom de famille',
					node:              'REPRE',
					op:                'detail',
					path:              [
						{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;LASTNAME', name: 'Nom de famille', flow: 'down', linker_kid: 0,
						},
					],
					type:              'K_NODE;STRING',
				},
			],
			from:   [
				{
					node: 'K_NODE;PERSON', name: 'Personne', type: 'K_NODE;STRING', inherits_extended: -1,
				},
			],
			where:  null,
			date:   '_NOW_',
		};

		$scope.ktableOptions = {
			actions: {
				insert:  true,
				delete:  true,
				update:  true,
				refresh: true,
			},
		};

		$scope.create = query => {
			console.log('create', query);
		};
	});
